/**
 * RequireAuthVerification - Route guard for email verification page
 * 
 * Ensures only authenticated enterprise users can access the email verification page.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import AuthLoadingScreen from '../../shared/AuthLoadingScreen';

function RequireAuthVerification({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth
  if (loading) {
    return <AuthLoadingScreen />;
  }

  // If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // CRITICAL: Only enterprise users should access verification page
  const isEnterpriseUser = user?.isEnterpriseUser === true || user?.isEnterprise === true;
    
  if (!isEnterpriseUser) {
    console.log('RequireAuthVerification: Non-enterprise user trying to access verification page, redirecting to app');
    return <Navigate to="/app/" replace />;
  }

  // User is authenticated enterprise user, allow access to verification page
  return children;
}

export default RequireAuthVerification;

